import { isRestrictedEmail } from '@coach-bot/data-access/shared/utils/permissions';
import { AnalyticsEvent } from '@coach-bot/features/analytics';
import { ContentScriptAction } from '@shared/extension/enums/content-script-action.enum';
import { StudyReelHostNames } from '@shared/extension/enums/study-reel-host-names.enum';
import { safeSendChromeMessageToTab } from '@shared/extension/utils/events';
import { isValidTab } from '@shared/extension/utils/tabs';
import { Services } from '../services';
import { handleTimeTracking, initiateThirdPartyAppLogin, safeSendStudyReelMessage, updateProfileEmail } from '../utils';

export const STUDY_REEL_PASSWORD = 'alpha.school';

export async function handleAuthStatusChanged(services: Services, email?: string): Promise<void> {
  try {
    await services.commonStore.setIsSignedIn(!!email);
    await services.commonStore.setLastSignInTime(Date.now());
    services.contextMenuService.updateContextMenuActions();
    await updateProfileEmail(services, email);
    if (email) {
      if (!isRestrictedEmail(email)) {
        initiateThirdPartyAppLogin();
      }
      safeSendStudyReelMessage(StudyReelHostNames.SendCredentials, {
        email,
        password: STUDY_REEL_PASSWORD,
        isTrackingOn: true,
      });
      await services.analyticsService.track(AnalyticsEvent.SignIn, {
        email,
        userId: services.commonStore.userId$.value,
        studentId: services.commonStore.studentId$.value,
      });
    } else {
      safeSendStudyReelMessage(StudyReelHostNames.SendCredentials, {
        email: '-',
        password: '-',
        isTrackingOn: false,
      });
      services.analyticsService.resetUser();
    }
    handleTimeTracking(services, email);
    chrome.tabs.query({}, function (tabs) {
      tabs.forEach(function (tab) {
        if (isValidTab(tab)) {
          safeSendChromeMessageToTab(tab.id!, {
            action: ContentScriptAction.ExtensionAuthStatusChanged,
            detail: { email: services.commonStore.profileEmail$.value },
          });
        }
      });
    });
  } catch (ex) {
    console.error('Error in handleAuthStatusChanged:', ex);
  }
}
